import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { MapView } from '../components/MapView';
import { MapAds } from './MapAds';
import { FilterSlider } from '../components/FilterSlider';
import { useSelector, useDispatch } from 'react-redux';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import { useAssets } from "expo-asset";

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ads: {
    position: "absolute",
    bottom: 10,
  },
  filters: {
    position: "absolute",
    left: 10,
    backgroundColor: "white",
    borderRadius: 2,
    shadowColor: "rgba(0, 0, 0, 0.3)",
    shadowOffset: {width: 1, height: 1},
  },
});

const mapPinOffsets = {
  [AppConstants.MAP_PIN_NAMES.GENERIC]: 4,
  [AppConstants.MAP_PIN_NAMES.CART]: 5,
  [AppConstants.MAP_PIN_NAMES.DINING]: 6,
  [AppConstants.MAP_PIN_NAMES.COFFEE_SHOP]: 7,
  [AppConstants.MAP_PIN_NAMES.FARMERS_MARKET]: 8,
  [AppConstants.MAP_PIN_NAMES.FARM]: 9,
  [AppConstants.MAP_PIN_NAMES.SEARCH]: 10,
  [AppConstants.MAP_PIN_NAMES.GPS]: 0,
}

export function Map({ navigation }) {
  const showFilterSlider = useSelector((state) => state.showFilterSlider);
  const [isFocused, setIsFocused] = React.useState(false);
  const [assets, assetsErrors] = useAssets([
    require('../../assets/crosshairs-gps-grey-25.png'),
    require('../../assets/plus-minus-variant-grey-25.png'),
    require('../../assets/truck-outline-grey-25.png'),
    require('../../assets/filter-outline-darkgrey.png'),
    require('../../assets/pins/pin_filled.png'),
    require('../../assets/pins/pin_cart.png'),
    require('../../assets/pins/pin_cutlery.png'),
    require('../../assets/pins/pin_coffee.png'),
    require('../../assets/pins/pin_farmersmarket.png'),
    require('../../assets/pins/pin_farm.png'),
    require('../../assets/pins/pin_grey_search.png'),
  ]);

  React.useEffect(() => {
    if (navigation) {
      return navigation.addListener("focus", () => {
        AppUtilities.info("Map focus");
        AppUtilities.recordAppPageView("map");
        setIsFocused(true);
      });
    }
  }, [navigation]);

  React.useEffect(() => {
    if (navigation) {
      return navigation.addListener("blur", () => {
        AppUtilities.info("Map blur");
        setIsFocused(false);
      });
    }
  }, [navigation]);

  if (!assets) return null;

  return (
    <View style={styles.wrapper}>
      {
        assets ?
            <MapView
              isFocused={isFocused}
              icons={assets}
              mapPinOffsets={mapPinOffsets}
              poiClickEnabled={false}
            />
          :
            null
      }
      <View style={styles.ads}>
        <MapAds navigation={navigation} />
      </View>
      {
        showFilterSlider ?
            <View style={styles.filters}>
              <FilterSlider vertical={true} />
            </View>
          :
            null
      }
    </View>
  );
}
